module.exports = __webpack_public_path__ + "img/Design_and_development_1200x800.e60d8004.png";